import axios from 'axios'
import http from '../api/http'
import store from '@/store'

export default {
  addNote: ({ receiptUuid, note }) => http.post('/receipts/add-note', { receiptUuid, note }),
  addProduct: (data) => {
    return store.dispatch('CANCEL_PENDING_REQUESTS')
      .then(() => {
        return http.post('/receipts/add-product', data)
      })
  },
  addReceiptDiscount: ({ discountType, discountValue }) => http.post('/receipts/add-receipt-discount', { discountType, discountValue, discountField: 'total_base_price' }),
  addReceiptDiscountStaff: () => http.post('/receipts/add-receipt-discount', { discountForStaff: true }),
  addRowDiscount: ({ receiptProductUuid, discountType, discountValue }) => http.post('/receipts/add-row-discount', { receiptProductUuid, discountType, discountValue, discountField: 'total_base_price', discountForStaff: false }),
  addRowDiscountStaff: ({ receiptProductUuid }) => http.post('/receipts/add-row-discount', { receiptProductUuid, discountForStaff: true }),
  addServiceRow: (data) => http.post('/receipts/add-service-row', data),
  addTransaction: ({ paymentMethodId, amount, payload = null }) => http.post('receipts/add-transaction', { paymentMethodId, amount, payload }),
  all: () => http.get('/receipts/all'),
  cancel: (receiptUuid) => http.post('/receipts/cancel', { receiptUuid }),
  changeProductPrice: (data) => http.post('/receipts/change-product-price', data),
  changeProductQuantity: (data) => http.post('/receipts/change-product-qty', data),
  changeSampleQuantity: (data) => http.post('/receipts/change-sample-qty', data),
  checkRefundNeeded: () => http.post('/receipts/check-refund-needed'),
  complete: () => http.post('/receipts/complete'),
  get: (receiptUuid = null) => {
    const source = axios.CancelToken.source()
    return store.dispatch('CANCEL_PENDING_REQUESTS')
      .then(() => {
        store.commit('ADD_CANCEL_TOKEN', source)
        return http.get('/receipts/get', { params: { receiptUuid }, cancelToken: source.token })
      })
  },
  getPrintHtml: (receiptUuid) => http.get('/receipts/get-print-html', { params: { receiptUuid } }),
  import: (receiptUuid) => http.post('/receipts/import', { receiptUuid }),
  pagination: (conditions, pagination) => http.get('/receipts/pagination', { params: { conditions, pagination }, timeout: 60000 }),
  park: (name) => http.post('/receipts/park', { name }),
  printed: (receiptUuid) => http.post('/receipts/printed', { receiptUuid }),
  removeProduct: (uuid) => http.delete('/receipts/remove-product', { data: { uuid } }),
  removeProducts: () => http.delete('/receipts/remove-products'),
  removeTransaction: (transactionUuid) => http.delete('receipts/remove-transaction', { data: { transactionUuid } }),
  sendEmailConfirmation: (receiptUuid) => http.post('receipts/send-email-confirmation', { receiptUuid }),
  setCustomer: (receiptUuid, customerUuid) => http.post('/receipts/set-customer', { receiptUuid, customerUuid }),
  setLanguage: (language) => http.post('/receipts/set-language', { language })
}
